import { FieldText } from './FieldText'

export const FieldEmail = ({ name, required, value, label, onChange, onInput, readOnly, placeholder, autoComplete = 'email', error }) => {
  return (
    <FieldText
      type={'email'}
      name={name}
      required={required}
      value={value}
      label={label}
      onChange={onChange}
      onInput={onInput}
      readOnly={readOnly}
      placeholder={placeholder}
      autoComplete={autoComplete}
      error={error}
    />
  )
}
